import * as i0 from '@angular/core';
import { InjectionToken, Component, ViewEncapsulation, Input, HostBinding, ViewChild, Inject, Injector, TemplateRef, Injectable, Optional, NgModule, SkipSelf } from '@angular/core';
import * as i1 from '@angular/animations';
import { trigger, transition, style, animate } from '@angular/animations';
import * as i2 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i3 from '@simpl/siemens-brand-localize';
import { SiLocalizationModule } from '@simpl/siemens-brand-localize';
import { DomPortalOutlet, ComponentPortal } from '@angular/cdk/portal';
import { BehaviorSubject } from 'rxjs';

const bottomAnimation = trigger('bottomTrigger', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(100%)' }),
        animate('300ms', style({ opacity: 1, transform: 'translateY(0%)' })),
    ]),
    transition(':leave', [
        style({ opacity: 1, transform: 'translateX(0%)' }),
        animate('300ms', style({ opacity: 0, transform: 'translateX(100%)' })),
    ]),
]);

var SiToastTypes;
(function (SiToastTypes) {
    SiToastTypes["SUCCESS"] = "success";
    SiToastTypes["INFO"] = "info";
    SiToastTypes["WARNING"] = "warning";
    SiToastTypes["DANGER"] = "danger";
})(SiToastTypes || (SiToastTypes = {}));
const SI_TOASTS = new InjectionToken('SI_TOASTS');
class SiToastRef {
    constructor(toast, hide) {
        this.toast = toast;
        this.hide = hide;
    }
}

class SiToastComponent {
    constructor(animationBuilder) {
        this.animationBuilder = animationBuilder;
    }
    get _toastClazz() { return `toast show toast-${this.toast.type} si-toast-no-body`; }
    get _timeoutClazz() { return !!this.toast.timeout; }
    ngOnInit() {
        if (this.toast.timeout) {
            const animation = this.animationBuilder.build([
                style({ transform: 'scaleX(100%)' }),
                animate(this.toast.timeout, style({ transform: 'scaleX(0%)' })),
            ]);
            animation.create(this._timeoutBarElement.nativeElement).play();
        }
    }
}
SiToastComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiToastComponent, deps: [{ token: i1.AnimationBuilder }], target: i0.ɵɵFactoryTarget.Component });
SiToastComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.7", type: SiToastComponent, selector: "si-toast", inputs: { toast: "toast" }, host: { properties: { "class": "this._toastClazz", "class.si-toast-timeout": "this._timeoutClazz" } }, viewQueries: [{ propertyName: "_timeoutBarElement", first: true, predicate: ["timeoutBar"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"toast-header\">\n    <span class=\"icon\" [ngClass]=\"toast.icon + ' text-reverse-theme-' + toast.type\"></span>\n    <div class=\"toast-content\">\n\n        <div *ngIf=\"toast.contentType === 'template'\">\n            <ng-container [ngTemplateOutlet]=\"toast.siToast.toast.content\"\n                          [ngTemplateOutletContext]=\"toast.context\"></ng-container>\n        </div>\n        <div *ngIf=\"toast.contentType === 'string'\">\n            {{toast.siToast.toast.content}}\n        </div>\n        <ng-container *ngIf=\"toast.contentType === 'component'\" [ngComponentOutlet]=\"toast.content\"\n                      [ngComponentOutletInjector]=\"toast.injector\"></ng-container>\n    </div>\n    <button *ngIf=\"!toast.hideClose\" type=\"button\" class=\"btn-close\" (click)=\"toast.siToast.hide()\"\n            [siLocalizeAttribute]=\"{'aria-label':'si-toast.close.aria-label'}\">\n    </button>\n</div>\n<div class=\"si-toast-timeout-bar\" #timeoutBar></div>\n", styles: ["si-toast{display:block;position:relative}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModule", "ngComponentOutletNgModuleFactory"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i3.SiLocalizeAttributeDirective, selector: "[siLocalizeAttribute]", inputs: ["siLocalizeAttribute"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiToastComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-toast', encapsulation: ViewEncapsulation.None, template: "<div class=\"toast-header\">\n    <span class=\"icon\" [ngClass]=\"toast.icon + ' text-reverse-theme-' + toast.type\"></span>\n    <div class=\"toast-content\">\n\n        <div *ngIf=\"toast.contentType === 'template'\">\n            <ng-container [ngTemplateOutlet]=\"toast.siToast.toast.content\"\n                          [ngTemplateOutletContext]=\"toast.context\"></ng-container>\n        </div>\n        <div *ngIf=\"toast.contentType === 'string'\">\n            {{toast.siToast.toast.content}}\n        </div>\n        <ng-container *ngIf=\"toast.contentType === 'component'\" [ngComponentOutlet]=\"toast.content\"\n                      [ngComponentOutletInjector]=\"toast.injector\"></ng-container>\n    </div>\n    <button *ngIf=\"!toast.hideClose\" type=\"button\" class=\"btn-close\" (click)=\"toast.siToast.hide()\"\n            [siLocalizeAttribute]=\"{'aria-label':'si-toast.close.aria-label'}\">\n    </button>\n</div>\n<div class=\"si-toast-timeout-bar\" #timeoutBar></div>\n", styles: ["si-toast{display:block;position:relative}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.AnimationBuilder }]; }, propDecorators: { toast: [{
                type: Input
            }], _toastClazz: [{
                type: HostBinding,
                args: ['class']
            }], _timeoutClazz: [{
                type: HostBinding,
                args: ['class.si-toast-timeout']
            }], _timeoutBarElement: [{
                type: ViewChild,
                args: ['timeoutBar', { static: true }]
            }] } });

class SiToastContainerComponent {
    constructor(toastComponentParameter) {
        this.toastComponentParameter = toastComponentParameter;
        this.globalToasts = true;
        this.trackByIdentity = (index, item) => item;
    }
    ngOnInit() {
        this.toasts = this.toastComponentParameter.toasts;
    }
}
SiToastContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiToastContainerComponent, deps: [{ token: SI_TOASTS }], target: i0.ɵɵFactoryTarget.Component });
SiToastContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.7", type: SiToastContainerComponent, selector: "ng-component", host: { properties: { "class.global-toasts": "this.globalToasts" } }, ngImport: i0, template: "<div class=\"toast-container\" aria-live=\"polite\">\n    <si-toast *ngFor=\"let toast of toasts | async; trackBy: trackByIdentity\" [toast]=\"toast\" @bottomTrigger></si-toast>\n</div>\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: SiToastComponent, selector: "si-toast", inputs: ["toast"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }], animations: [bottomAnimation] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiToastContainerComponent, decorators: [{
            type: Component,
            args: [{ animations: [bottomAnimation], template: "<div class=\"toast-container\" aria-live=\"polite\">\n    <si-toast *ngFor=\"let toast of toasts | async; trackBy: trackByIdentity\" [toast]=\"toast\" @bottomTrigger></si-toast>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [SI_TOASTS]
                }] }]; }, propDecorators: { globalToasts: [{
                type: HostBinding,
                args: ['class.global-toasts']
            }] } });

const iconMap = {
    'success': 'siemens-success',
    'info': 'siemens-information',
    'danger': 'siemens-error',
    'warning': 'siemens-warning',
};
class SiToastService {
    constructor(componentFactoryResolver, injector, appRef, document, toastContainer) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this.appRef = appRef;
        this.document = document;
        this.toastContainer = toastContainer;
        this.toasts = new BehaviorSubject([]);
        this.openToasts = [];
        this.createToastContainer();
    }
    /**
     * Creates a new Toast which is displayed on top of the page.
     * @param toast
     * content: can be of type string or Template
     * type?: type of the toast. Default: INFO
     * timeout?: number of milliseconds after which the toast should be dismissed
     * @returns A reference to the displayed toast instance
     */
    showToast(toast) {
        const toastRef = new SiToastRef(toast, () => this.hideToast(toast));
        const toastWrapper = this.toToastWrapper(toast);
        this.openToasts.push(toastWrapper);
        this.toasts.next(this.openToasts);
        if (toast.timeout) {
            setTimeout(() => {
                this.hideToast(toast);
            }, toast.timeout);
        }
        return toastRef;
    }
    hideToast(toast) {
        this.openToasts = this.openToasts.filter(t => t.siToast.toast !== toast);
        this.toasts.next(this.openToasts);
    }
    createToastContainer() {
        const targetLocation = this.toastContainer?.nativeElement ?? this.document.body;
        if (!this.portalHost) {
            this.portalHost = new DomPortalOutlet(targetLocation, this.componentFactoryResolver, this.appRef, Injector.create({
                providers: [{
                        provide: SI_TOASTS,
                        useValue: {
                            toasts: this.toasts.asObservable(),
                            globalToasts: targetLocation === this.document.body,
                        },
                    }],
                parent: this.injector,
            }));
        }
        this.portal = new ComponentPortal(SiToastContainerComponent);
        this.portalHost.detach();
        // otherwise changeDetection error
        setTimeout(() => {
            this.toastComponentRef = this.portalHost.attach(this.portal);
        }, 0);
    }
    toToastWrapper(toast) {
        const base = {
            type: toast.type ?? SiToastTypes.INFO,
            hideClose: toast.hideClose ?? false,
            timeout: toast.timeout,
            siToast: new SiToastRef(toast, () => this.hideToast(toast)),
        };
        base.icon = toast.iconClass ?? iconMap[base.type];
        if (this.isStringToast(toast)) {
            return {
                ...base,
                contentType: 'string',
            };
        }
        else if (this.isTemplateToast(toast)) {
            return {
                ...base,
                contentType: 'template',
                context: { ...toast.context, toastRef: base.siToast },
            };
        }
        else {
            return {
                ...base,
                contentType: 'component',
                injector: Injector.create({
                    providers: [{ provide: SiToastRef, useValue: base.siToast }],
                    parent: toast.injector ?? this.injector,
                }),
                content: toast.content,
            };
        }
    }
    isStringToast(toast) {
        return typeof toast.content === 'string';
    }
    isTemplateToast(toast) {
        return toast.content instanceof TemplateRef;
    }
}
SiToastService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiToastService, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.Injector }, { token: i0.ApplicationRef }, { token: DOCUMENT }, { token: i0.ElementRef, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
SiToastService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiToastService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiToastService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.Injector }, { type: i0.ApplicationRef }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ElementRef, decorators: [{
                    type: Optional
                }] }]; } });

class SiToastModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('SiToastModule was already loaded. Import it in the AppModule only');
        }
    }
}
SiToastModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiToastModule, deps: [{ token: SiToastModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule });
SiToastModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.7", ngImport: i0, type: SiToastModule, declarations: [SiToastComponent, SiToastContainerComponent], imports: [CommonModule, SiLocalizationModule] });
SiToastModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiToastModule, providers: [SiToastService], imports: [CommonModule, SiLocalizationModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiToastModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiToastComponent, SiToastContainerComponent],
                    imports: [CommonModule, SiLocalizationModule],
                    exports: [],
                    providers: [SiToastService],
                }]
        }], ctorParameters: function () { return [{ type: SiToastModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { SI_TOASTS, SiToastComponent, SiToastContainerComponent, SiToastModule, SiToastRef, SiToastService, SiToastTypes };
